<template>
  <v-card class="pa-0">
    <v-list-item class="grow">
      <v-list-item-avatar v-if="avatar" color="grey darken-3">
        <v-img class="elevation-6" :alt="fullName" :src="avatar"></v-img>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title>
          {{ title }}
        </v-list-item-title>
        <v-list-item-subtitle class="wrap-subtitle-author">
          {{ fullName }} {{ subtitle }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-card-text v-if="description">
      {{ description }}
    </v-card-text>
    <div v-if="list.length">
      <v-card-text>More {{ itemType }} by {{ author.first_name }}</v-card-text>
      <v-list>
        <v-list-item v-for="item in list" :key="item.id" class="grow">
          <v-list-item-avatar>
            <nuxt-link :to="item.url">
              <v-img
                width="50"
                height="50"
                class="elevation-6"
                :alt="item.title"
                :src="$config.staticUrl + item.thumbnail"
              ></v-img>
            </nuxt-link>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              <nuxt-link :to="item.url">
                {{ item.title }}
              </nuxt-link>
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ item.subtitle }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
  </v-card>
</template>
<script>
export default {
  name: 'AuthorCard',
  props: {
    author: {
      type: Object,
      default: () => ({}),
    },
    items: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: () => '',
    },
    source: {
      type: String,
      default: () => '',
    },
  },
  data() {
    const getList = (items, type) => {
      if (type === 'activities') {
        return items.map((act) => ({
          id: act.id,
          title: act.headline,
          subtitle: act.short_description.slice(0, 150),
          url: `/activity/${act.slug}`,
          thumbnail:
            act.header_thumbnail ||
            require('@/assets/images/happylyApprovedBadge.png'),
        }))
      } else if (type === 'plans') {
        return items.map((plan) => ({
          id: plan.id,
          title: plan.name,
          subtitle: plan.message.slice(0, 150),
          url: `/curated_plans/${plan.id}`,
          thumbnail: plan.activities.length
            ? plan.activities[0].activity.header_thumbnail
            : require('@/assets/images/happylyApprovedBadge.png'),
        }))
      } else if (type === 'posts') {
        return items.map((post) => ({
          id: post.id,
          title: post.title,
          subtitle: post.intro.slice(0, 150),
          url: `/blog/${post.slug}`,
          thumbnail: post.main_image
            ? post.main_image.thumbnail
            : require('@/assets/images/happylyApprovedBadge.png'),
        }))
      } else {
        return []
      }
    }

    return {
      avatar: this.author.optimized_profile
        ? `${this.$config.staticUrl}${this.author.optimized_profile}`
        : require('@/assets/images/happylyApprovedBadge.png'),
      fullName:
        this.author.full_name ||
        (this.source === 'COMMUNITY' ? 'A' : 'The happyly team'),
      description: this.author.description || '',
      title:
        this.source === 'COMMUNITY'
          ? 'Thoughtfully shared by:'
          : 'Thoughtfully captured by:',
      subtitle: this.source === 'COMMUNITY' ? 'happyly community member.' : '',
      itemType: this.type,
      list: getList(this.items, this.type),
    }
  },
}
</script>
<style>
.wrap-subtitle-author {
  white-space: normal !important;
}
</style>
